import { FONT_FAMILY_OPTIONS, DEFAULT_PAGE_FONT_FAMILY } from "./constants";

// ============================================================
// LOAD GOOGLE FONT
// ============================================================
export const loadGoogleFont = (fontName) => {
  if (!fontName) {
    return;
  }

  const id = `google-font-${fontName.toLowerCase().replace(/\s+/g, "-")}`;

  if (document.getElementById(id)) {
    return;
  }

  const link = document.createElement("link");

  link.id = id;
  link.rel = "stylesheet";

  const encodedFontName = encodeURIComponent(fontName).replace(/%20/g, "+");

  link.href = `https://fonts.googleapis.com/css2?family=${encodedFontName}:wght@300;400;500;600;700;800&display=swap`;

  document.head.appendChild(link);
};

// ============================================================
// SELECTED FONT FAMILY
// ============================================================

export const getSelectedFontFamily = (fontFamily) => {
  const selectedValue = fontFamily || DEFAULT_PAGE_FONT_FAMILY;

  return (
    FONT_FAMILY_OPTIONS.find((font) => font.value === selectedValue) ||
    FONT_FAMILY_OPTIONS.find((font) => font.value === DEFAULT_PAGE_FONT_FAMILY)
  );
};
